import { AbstractControl } from '@angular/forms';

import { IUser } from '../../services/data/models/interfaces';

import * as dayjs from 'dayjs';

const HAS_ERROR = true;

/**
 * Check that control value is a date that is the same or after from date
 * @param control Angular form control
 * @param is_from Comparison date(ms from UTC epoch). Defaults to the current time
 */
export function validateDate(control: AbstractControl, is_from: number = dayjs().valueOf()) {
    const from = dayjs(is_from);
    const date = dayjs(control.value || undefined);
    return date.isBefore(from, 'd') ? { date: HAS_ERROR, message: 'Booking needs to be made in the future' } : null;
}

/**
 * Build start time validation function
 * @param date Date of the time to check
 * @param is_from Comparison date(ms from UTC epoch). Defaults to the current time
 */
export function buildValidateStartTime(date: number, is_from?: number) {
    if (!is_from) {
        const from = dayjs(is_from);
        is_from = from.minute(Math.floor(from.minute() / 5) * 5).valueOf();
    }
    return (c) => validateStartTime(c, date, is_from);
}

/**
 * Check that control value time is after the comparison date time
 * @param control Angular form control
 * @param date Date of the time to check
 * @param is_from Comparison date(ms from UTC epoch). Defaults to the current time
 */
export function validateStartTime(control: AbstractControl, date: number, is_from: number = dayjs().valueOf()) {
    const now = dayjs(is_from);
    const parts = control.value.split(':');
    const date_obj = dayjs(date).hour(+parts[0]).minute(+parts[1]);
    return date_obj.isBefore(now, 'm') ? { start: HAS_ERROR, message: 'Booking time needs to be made in the future' } : null;
}

export function buildValidateDuration(min: number = 10, max: number = 480) {
    return (c) => validateDuration(c, min, max);
}

export function validateDuration(control: AbstractControl, min: number = 10, max: number = 480) {
    if (control.value < (min || 30)) {
        return { duration: HAS_ERROR, message: `Minimum booking duration is ${min} minute${min === 1 ? 's' : ''}` };
    } else if (control.value > (max || 480)) {
        return { length: HAS_ERROR, message: `Maximum booking duration is ${max} minute${max === 1 ? 's' : ''}` };
    }
    return null;
}

export function buildValidateAttendees(host: string, min: number = 0) {
    return (c) => validateAttendees(c, host, min);
}

export function validateAttendees(control: AbstractControl, hostEmail: string, min: number = 0) {
    if (!control || !(control.value instanceof Array)) {
        return min > 0
            ? { invalid: true, message: `Minimum of ${min} attendee${min === 1 ? ' is' : 's are'} required other than host` }
            : null;
    }
    const list: IUser[] = control.value;
    if (hostEmail) {
        const result = list.find(a => a.email === hostEmail);
        if (result) { list.splice(list.indexOf(result), 1); }
    }
    return list.length >= min ? null : {
        count: true,
        message: `Minimum of ${min} attendee${min === 1 ? ' is' : 's are'} required other than host`
    };
}
